// ============================================================================
// note-client-mod -- 动画 & 过渡常量
//
// 用于内联样式的动画配置，保持一致的动效体验。
// ============================================================================
import { transition } from './theme.js';
export const animations = {
    listItemEnter: {
        animation: 'note-fade-in-up 0.25s ease forwards',
    },
    modalEnter: {
        animation: 'note-scale-in 0.2s ease forwards',
    },
    exit: {
        animation: 'note-fade-out 0.15s ease forwards',
    },
    pulse: {
        animation: 'note-pulse 1.5s ease-in-out infinite',
    },
    shake: {
        animation: 'note-shake 0.4s ease',
    },
};
/** 全局动画关键帧（通过注入 <style> 标签生效） */
export const KEYFRAMES_CSS = `
@keyframes note-fade-in-up {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes note-fade-out {
  from { opacity: 1; }
  to { opacity: 0; }
}

@keyframes note-scale-in {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes note-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes note-shake {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-4px); }
  40%, 80% { transform: translateX(4px); }
}

@keyframes note-slide-down {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 通用工具类 */
.note-btn-transition {
  transition: background-color ${transition.fast}, border-color ${transition.fast}, color ${transition.fast}, box-shadow ${transition.fast};
}
`;
/** 悬停过渡效果 */
export function hoverTransition(style = {}) {
    return {
        ...style,
        transition: `background-color ${transition.fast}, border-color ${transition.fast}, color ${transition.fast}, box-shadow ${transition.fast}, transform ${transition.fast}`,
    };
}
/** 按钮基础样式 + 悬停态 */
export function buttonBase(overrides = {}) {
    return hoverTransition({
        cursor: 'pointer',
        fontFamily: 'inherit',
        outline: 'none',
        border: 'none',
        ...overrides,
    });
}
/** 输入框基础样式 */
export function inputBase(theme) {
    return {
        padding: '8px 12px',
        border: `1px solid ${theme.border.default}`,
        borderRadius: '6px',
        fontSize: '14px',
        outline: 'none',
        backgroundColor: theme.bg.tertiary,
        transition: `border-color ${transition.fast}, box-shadow ${transition.fast}`,
    };
}
//# sourceMappingURL=animations.js.map